import { render, staticRenderFns } from "./BugReportDialog.vue?vue&type=template&id=464a78b6"
import script from "./BugReportDialog.vue?vue&type=script&lang=ts"
export * from "./BugReportDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports